import React from 'react';
import TopBar from './TopBars/TopBar';
import { cn } from '@/lib/utils';

const Page = ({ children, className, ...props }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => {
    return (
        <div className={cn('flex h-screen flex-col', className)} {...props}>
            <TopBar />
            {children}
        </div>
    );
};

export default Page;
